module.exports = __webpack_public_path__ + "img/aquarell_1920_1080_mit_wasserzeichen_22_10.bb54602a.jpg";